import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { HiveMessageModalComponent } from './components/hivemessage-modal.component';
import { MobilePhoneHiveMessageComponent } from './components/mobile-phone-hivemessage.component';
import { HiveMessageService } from './services/hivemessage.service';

@NgModule({ 
  declarations: [
    HiveMessageModalComponent,
    MobilePhoneHiveMessageComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [HiveMessageService],
  exports: [
    HiveMessageModalComponent,
    MobilePhoneHiveMessageComponent
  ]
})
export class HiveMessageModule { }
